import type { Locale } from "./content/types";

export const prismarkConfig: { appStoreUrl: Record<Locale, string> } = {
  // 按页面语言选商店地区（简体页 /cn、繁体页 /tw、英文页 /us）：不带地区码的链接在 Mac 网页版会被苹果跳到 Today 页。
  appStoreUrl: {
    en: "https://apps.apple.com/us/app/id6771652764",
    zh: "https://apps.apple.com/cn/app/id6771652764",
    "zh-Hant": "https://apps.apple.com/tw/app/id6771652764"
  }
};
